module.exports = __webpack_public_path__ + "assets/img/s5-tab-3-active-e2dddbaf.png";